// extracted by mini-css-extract-plugin
export default {"container":"Tips_container__jtikM","tips":"Tips_tips__oZC6n","inputContainer":"Tips_inputContainer__doRqf","left_block":"Tips_left_block__tlnHG","input":"Tips_input__M2COr"};